<template v-if='pageData[fieldKey]'>
    <!-- Dynamically render the imported component -->
    <component v-if='pageData[fieldKey]?.isEditable && inputTypeComponent' 
        :is="inputTypeComponent" 
        :fieldKey="fieldKey"
        :pageData="pageData"
    >
    </component>
    <KeyValue v-else-if='pageData[fieldKey].label'
        :item='pageData[fieldKey]'
    ></KeyValue>
</template>

<script setup>
import { defineProps, toRefs, defineAsyncComponent, shallowRef } from 'vue';
import KeyValue from "@/components/interface/KeyValue2.vue";
const props = defineProps(['fieldKey', 'pageData']);
const { fieldKey, pageData } = toRefs(props);
const inputTypeComponent = shallowRef(null);
inputTypeComponent.value = defineAsyncComponent(() =>
    import(`@/components/views/inputs/${pageData.value[fieldKey.value].type}Input.vue`)
);
</script>
  